Alpine.data('button', () => ({
    loading: false,

    setLoading(loading) {
        this.loading = loading;
    },
}));
